module EEX.McEc.Controls.CertificateDialog {

    // ReSharper disable once InconsistentNaming
    export interface ChooseKeyPairSourceAttribute extends CertificateDialogBaseAttribute {
    }

    export class ChooseKeyPairSourceModel extends CertificateDialogBaseModel<ChooseKeyPairSourceAttribute> {


        constructor(model: CertificateDialogModel, processStep: number) {
            super(model, processStep);
        }
    }

    // ReSharper disable once InconsistentNaming
    export interface ChooseKeyPairSourceOptions extends CertificateDialogBaseOptions {
    }

    export class ChooseKeyPairSourceView extends CertificateDialogBaseView<ChooseKeyPairSourceModel> {
        model: ChooseKeyPairSourceModel;

        private createNewCallback: () => void;
        private chooseExistingCallback: () => void;

        private buttons: {
            createNew: JQuery,
            chooseExisting: JQuery,
        }

        constructor(model: ChooseKeyPairSourceModel, target: HTMLElement, options?: ChooseKeyPairSourceOptions) {
            super(model,
                target,
                McEc.Templates.CertificateDialog_ChooseKeyPairSource,
                AppKitchen.OptionsHelper.merge(options,
                    {
                        title: McEc.Strings.CertificateDialog_ChooseKeyPairSource_Title
                    }));
        }

        render() {
            super.render();
            this.setButtons();
            this.setButtonsAction();
            return this;
        }

        private setButtons(): void {
            this.buttons = {
                createNew: this.$el.find(".create-new-key-pair-btn"),
                chooseExisting: this.$el.find(".choose-key-pair-btn"),
            }
        }

        private setButtonsAction(): void {
            this.buttons.createNew.click(() => {
                if (this.createNewCallback) {
                    this.createNewCallback();
                }
            });
            this.buttons.chooseExisting.click(() => {
                if (this.chooseExistingCallback) {
                    this.chooseExistingCallback();
                }
            });
        }

        public createNew(createNew: () => void): void {
            this.createNewCallback = createNew;
        }

        public chooseExisting(chooseExisting: () => void): void {
            this.chooseExistingCallback = chooseExisting;
        }
    }
}
